export default __webpack_public_path__ + "static/media/img-24-burvis.ee545de9.jpg";